import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import * as React from 'react';

import { AdfoxBannerTGBBetweenOffers } from '../../components/AdfoxBanner';
import { AD_BANNER_MF_MANIFEST_SETTING_KEY } from '../../constants/adBannerMicrofrontend';
import { useApplicationContext } from '../../utils/applicationContext';
import { AdBannerMicrofrontendTgbBetweenOffersContainer } from '../AdBannerMicrofrontendTgbBetweenOffersContainer';

type TBannerTgbBetweenOffersContainerProps = {
  position: number;
};

/**
 * Фича-флаговый шов: манифест в конфиге есть — рендерим микрофронтенд ad-banner-frontend,
 * нет — легаси-баннер на @cian/adfox-component.
 */
export const BannerTgbBetweenOffersContainer: React.FC<TBannerTgbBetweenOffersContainerProps> = ({ position }) => {
  const { config } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest>(AD_BANNER_MF_MANIFEST_SETTING_KEY);

  return manifest ? (
    <AdBannerMicrofrontendTgbBetweenOffersContainer manifest={manifest} position={position} />
  ) : (
    <AdfoxBannerTGBBetweenOffers position={position} />
  );
};
